"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mozzagrogna": {
    "0ed2a334": [{
      "hkey": "ad1ad093",
      "slug": "mozzagrogna",
      "name": "Mozzagrogna",
      "primary": true,
      "skipSearch": false
    }],
    "castelli": [{
      "hkey": "ad1ad093",
      "slug": "mozzagrogna",
      "name": "Mozzagrogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0fc7da71": [{
      "hkey": "d3b8b74d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centri-urbani-mozzagrogna": [{
      "hkey": "d3b8b74d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "31e4efee": [{
      "hkey": "ad1ad093",
      "slug": "mozzagrogna",
      "name": "Mozzagrogna",
      "primary": true,
      "skipSearch": false
    }],
    "colle-ruzzo": [{
      "hkey": "ad1ad093",
      "slug": "mozzagrogna",
      "name": "Mozzagrogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b6444945": [{
      "hkey": "ad1ad093",
      "slug": "mozzagrogna",
      "name": "Mozzagrogna",
      "primary": true,
      "skipSearch": false
    }],
    "cuna-re-di-coppe": [{
      "hkey": "ad1ad093",
      "slug": "mozzagrogna",
      "name": "Mozzagrogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "681fbecd": [{
      "hkey": "ad1ad093",
      "slug": "mozzagrogna",
      "name": "Mozzagrogna",
      "primary": true,
      "skipSearch": false
    }],
    "fonte-della-noce": [{
      "hkey": "ad1ad093",
      "slug": "mozzagrogna",
      "name": "Mozzagrogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f8ac7120": [{
      "hkey": "ad1ad093",
      "slug": "mozzagrogna",
      "name": "Mozzagrogna",
      "primary": true,
      "skipSearch": false
    }],
    "ponticelli": [{
      "hkey": "ad1ad093",
      "slug": "mozzagrogna",
      "name": "Mozzagrogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;